module.exports = __webpack_public_path__ + "img/htu-3-1.067da18b.png";